/**
 * @file AddBtn
 */

'use strict';
import Template from '../../Template/Template';
import Common from "../../Utils/Common";

/**
 * @classname BtnAdd
 * @classdesc BtnAdd
 */
export default class BtnAdd {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-add')
	 */
	constructor($e, controller) {
		console.log(`BtnAdd.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._type = $e.attr('data-add-type');
		this._$base = $e.closest($e.attr('data-base-object'));
		this._max = $e.attr('data-max') || 99;
		this._$e.on('click', () => this.onClick());
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof AddBtn
	 * @return {undefined}
	 */
	onClick() {
		console.log(`BtnAdd.onClick`);
		let html = '';
		const idx = this._$base.parent().children().length;
		console.log(`${idx}/${this._max}`);
		if(idx >= this._max) {
			Common.showErrorModal(`これ以上は追加できません。`);
			return;
		}
		switch(this._type){
			case 'operator':
				{
					html = Template.Operator(idx);
				}
				break;
			case 'paid-mutual-aid':
				{
					html = Template.PaidMutualAid(idx);
				}
				break;
			case 'administrational-operator':
				{
					let responseName = this._$base.find('.selected-member-id-dummy').data('response-name');
					html = Template.AdministrationalOperator(idx, responseName);
				}
				break;
			case 'general-operator':
				{
					let responseName = this._$base.find('.selected-member-id-dummy').data('response-name');
					html = Template.GeneralOperator(idx, responseName);
				}
				break;
			case 'supporter':
				{
					html = Template.Supporter(idx);
				}
				break;
			case 'divide-contribution':
				{
					html = Template.DivideContribution(idx);
				}
				break;
			case 'divide-contribution2':
				{
					html = Template.DivideContribution2(idx);
				}
				break;
		}
		this._$base.after(html);
		const $addedItem = this._$base.next('.list-item');
		console.log($addedItem);
		this._controller.activateAddedItem($addedItem, this._$base);
	};
}
